import { Injectable } from '@angular/core';
import { apiEndpoints } from '../../constants/api-endpoints';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class LeadBuyerServiceService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  userEmail = sessionStorage.getItem('UserEmail') || '';

  getAssignedLeadBuyerPNARequests(params: any): Observable<HttpResponse<any>> {
    const url = `${apiEndpoints.getAssignedLeadBuyerPNARequests}`;
    return this.httpUtilityService.getByParam(url, params);
  }

  pnaRequestLeadBuyerAction(payload: any): Observable<HttpResponse<any>> {
    return this.httpUtilityService.post<any>(
      apiEndpoints.pnaRequestLeadBuyerAction,
      payload
    );
  }

  otherLeadBuyerPnaSearch(filter: any, pageNumber: number, pageSize: number) {
    const url = `${apiEndpoints.OtherLeadBuyerPnaSearch}?req_userEmail=${this.userEmail}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.httpUtilityService.post<any[]>(url, filter);
  }
}
